module.exports = __webpack_public_path__ + "img/kairat-logo-icon.0132ab96.png";